import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { StopMessageAndBeep } from 'src/myfunc';
import { CustomLabel, Label, LatLong, WayPoint } from 'src/app/Model/Shipping/way-point';
import { MapsAPILoader } from '@agm/core';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-new-order-dialog',
  templateUrl: './new-order-dialog.component.html',
  styleUrls: ['./new-order-dialog.component.css']
})
export class NewOrderDialogComponent {

  employeeCode: string;
  refNo: string;

  constant: Constant = new Constant();
  errorLog: ErrorLog = new ErrorLog();

  message: string;
  distance: string;
  price: string;
  fromAddress: string;
  toAddress: string;
  latitude: number;
  longitude: number;

  storeLatitude: number;
  storeLongitude: number;
  zoom: number;

  // showDetails: boolean = true;
  showCloseIcon: boolean = false;
  public searchElementRef: ElementRef;

  public renderOptions = {
    suppressMarkers: true,
  };

  //For Google Map
  // latitude: number;
  // longitude: number;

  lastLati: number;
  lastLongi: number;
  origin: LatLong = new LatLong();
  destination: LatLong = new LatLong();
  waypoints: WayPoint[] = [];
  customLabel: CustomLabel[] = [];
  isShowMap: boolean = false;

  markerOptions = {
    destination: { label: { color: 'white', text: 'PL' }, infoWindow: '' },
    origin: {
      visible: true, infoWindow: ''
    }
    //, waypoints: this.customLabel
  };

  acceptOrderSubscription: Subscription;

  zoomMap = 14;

  center!: google.maps.LatLngLiteral;

  origin1!: google.maps.LatLngLiteral;
  destination1!: google.maps.LatLngLiteral;

  directionsService = new google.maps.DirectionsService();
  directionsResults: google.maps.DirectionsResult | undefined;

  mapOptions: google.maps.MapOptions = {
    fullscreenControl: false,
    streetViewControl: false
  };

  originMarkerOptions: google.maps.MarkerOptions = {
    draggable: false
  };

  destinationMarkerOptions: google.maps.MarkerOptions = {
    draggable: false
  };

  constructor(
    private dialogRef: MatDialogRef<NewOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private toastService: ToastrService,
    private apiFactory: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private shippingManagerService: ShippingManagerService,
    private router: Router,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,

  ) {
    dialogRef.disableClose = true;
    this.refNo = dialogData.refNo;
    this.message = dialogData.message;
    this.employeeCode = JSON.parse(this.persistenceService.get("google_email"));
    console.log(this.refNo);
    console.log(this.message);

  }

  ngOnInit() {
    // Split the message string by "===" to extract the values
    const parts = this.message.split("===");
    console.log(parts);
    parts.forEach(part => {
      if (part.startsWith("Distance:")) {
        this.distance = part.replace("Distance:", "").trim();
      } else if (part.startsWith("Price:")) {
        this.price = part.replace("Price:", "").trim();
      } else if (part.startsWith("FromAddress:")) {
        this.fromAddress = part.replace("FromAddress:", "").trim();
      } else if (part.startsWith("ToAddress:")) {
        this.toAddress = part.replace("ToAddress:", "").trim();
      } else if (part.startsWith("Latitude:")) {
        this.latitude = Number(part.replace("Latitude:", "").trim());
        this.lastLati = this.latitude;
      } else if (part.startsWith("Longitude:")) {
        this.longitude = Number(part.replace("Longitude:", "").trim());
        this.lastLongi = this.longitude;
      }
    });
    console.log(this.distance);
    console.log(this.price);
    console.log(this.fromAddress);
    console.log(this.toAddress);
    console.log(this.latitude);
    console.log(this.longitude);


    this.getGoogleMap();
    // this.getCurrentLocation();
    // this.drawMapData();
  }

  // ngAfterViewInit() {
  //   this.getCurrentLocation();      // Main map
  // }

  hide() {
    this.dialogRef.close()
  }

  onAcceptOrDeclineClick(status: string) {

    this.acceptOrderSubscription = this.shippingManagerService.acceptOrder(this.apiFactory.acceptOrderByOrderNo, this.refNo, this.employeeCode, status)
      .subscribe((data) => {
        if (data) {
          if (status == 'Rider Accepted') {
            this.toastService.showSuccessToast('Order Accepted Successfully');
            this.dialogRef.close(true);
            // this.showDetails = false;
            this.showCloseIcon = true;
          } else {
            this.toastService.showSuccessToast('Order Declined Successfully');
            this.dialogRef.close(false);
          }
        }
      },
        (error: HttpErrorResponse) => {
          this.toastService.clearAllToast();
          this.toastService.showErrorToast('This order has already been accepted');
          this.dialogRef.close(false);
          this.insertErrorLog("onAcceptClick", error);
        });
    StopMessageAndBeep();
  }

  //Google map
  getGoogleMap() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();

    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.storeLatitude = position.coords.latitude;
        console.log(this.storeLatitude);
        this.storeLongitude = position.coords.longitude;
        // this.zoom = 8;
        this.drawMapData();
      });
    }
  }

  drawMapData() {
    this.waypoints = [];
    this.customLabel = [];


    this.origin.lat = this.storeLatitude;
    console.log(this.origin.lat);
    this.origin.lng = this.storeLongitude;
    console.log(this.origin.lng);



    this.destination.lat = this.lastLati;
    console.log("XXXXX" + this.destination.lat);
    this.destination.lng = this.lastLongi;
    console.log("XXXXX" + this.destination.lng);


    let url = "";
    if (this.getOS() == "Android")
      url = 'geo:' + this.destination.lat + ',' + this.destination.lng
    else
      url = 'https://www.google.com/maps/dir/' + this.origin.lat + ',' + this.origin.lng + '/' + this.destination.lat + ',' + this.destination.lng;
    this.markerOptions.destination.infoWindow = this.fromAddress + "<br><a href=" + url + " target='_blank'>View on google maps</a>"
    //  this.markerOptions.origin.infoWindow=this.toAddress+"<br><a href="+url+" target='_blank'>View on google maps</a>"





    let index: number;

    console.log(this.markerOptions)

    this.isShowMap = true;

    //this.getGoogleMap();

  }

  onMarkerClick() {
    const url = `https://www.google.com/maps?q=${this.storeLatitude},${this.storeLongitude}`;
    window.open(url, '_blank');
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }


  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }

  // ✅ Get user location
  getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {

        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        this.origin = { lat, lng };
        this.center = { lat, lng };

        // 🔴 SET YOUR DESTINATION HERE
        this.destination = {
          lat: this.lastLati,      // your existing value
          lng: this.lastLongi
        };

        this.drawRoute();
      });
    }
  }

  // ✅ Draw route (modern way)
  drawRoute() {

    if (!this.origin || !this.destination) return;

    this.directionsService.route(
      {
        origin: this.origin,
        destination: this.destination,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === 'OK') {
          this.directionsResults = result!;
        } else {
          console.error('Directions request failed:', status);
        }
      }
    );
  }

  // optional marker drag handler
  onMarkerDrag(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      console.log(event.latLng.toJSON());
    }
  }

}
